<template>
    <div class="symbol-group symbol-hover mb-3">
        <div v-for="user in getFourFollowers" :key="user.id" :class="'symbol-'+symbolSize" class="symbol symbol-circle" :title="user?.firstname+' '+user?.lastname">
            <span v-if="!user.link" class="symbol-label fw-bolder" style="background-color: rgba(0, 114, 206, 0.25); color: rgba(0, 114, 206, 1);">{{ user?.firstname && user?.firstname[0]?.toUpperCase() }} {{user?.lastname && user?.lastname[0]?.toUpperCase()}}</span>
            <img v-else :src="user.link" />
        </div>
        <a v-if="data.length - getFourFollowers.length > 0" class="symbol symbol-35px symbol-circle" @click="openUsersModal">
            <span class="symbol-label bg-dark text-inverse-dark fs-8 fw-bolder" >+{{data.length - getFourFollowers.length}}</span>
        </a>
    </div>

</template>
<script setup>
    import {onMounted, ref, computed} from "vue";

    const props = defineProps({
        data: {
            type: Array,
            default: [{firstname: 'Anonyme', lastname: ''}]
        },
        size: {type: Number, default: 1},
        symbolSize: {type: String, default: "35px"}
    })

    const getFourFollowers = computed(() => {
        return props.data?.slice(0, props.size)
    })

</script>

<style scoped>

</style>
